import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ContactSpreadsheetHeader from './components/ContactSpreadsheetHeader';
import UploadPlaceholder from '../../../../apps/pro/views/AccountAddressBook/components/AddressBookCSVUpload/components/UploadPlaceholder';
import ColumnMatcher from '../../../../apps/pro/views/AccountAddressBook/components/AddressBookCSVUpload/components/ColumnMatcher';
import useContactSpreadsheetImport from './useContactSpreadsheetImport';
import ContactSpreadsheetImportInvalidRowEditor from './components/ContactSpreadsheetImportInvalidRowEditor';
import Alert from '../../../../components/global/Alert';

const propTypes = {
  className: PropTypes.string,
  onRequestClose: PropTypes.func,
  onSuccess: PropTypes.func,
  onImport: PropTypes.func,
};

const ContactSpreadsheetImport = ({
  className,
  onRequestClose,
  onSuccess,
  onImport,
}) => {
  const classes = classNames({
    'contact-spreadsheet-import': true,
    [className]: !!className,
  });
  const {
    loading,
    importData,
    setImportData,
    invalidRows,
    onDataCreate,
    error,
  } = useContactSpreadsheetImport({
    onSuccess: () => {
      onRequestClose?.();
      onSuccess?.();
    },
    onImport,
  });

  return (
    <div className={classes}>
      <ContactSpreadsheetHeader />

      {error && <Alert type="danger">{error}</Alert>}

      {!importData && (
        <UploadPlaceholder
          onDataReceived={data => {
            setImportData(data);
          }}
          onCancel={onRequestClose}
        />
      )}

      {importData && !invalidRows.length && (
        <ColumnMatcher
          data={importData}
          onContinue={data => onDataCreate(data)}
          onCancel={onRequestClose}
          loading={loading}
        />
      )}

      {invalidRows.length > 0 && (
        <ContactSpreadsheetImportInvalidRowEditor
          initialRows={invalidRows}
          importData={importData}
          loading={loading}
          onCancel={onRequestClose}
          onContinue={rows => onDataCreate(rows, false)}
        />
      )}
    </div>
  );
};

ContactSpreadsheetImport.propTypes = propTypes;

export default ContactSpreadsheetImport;
